import Network from '@/common/lib/Network';
import Store from '@/config/store';

export default {

  getDocument() {

    let params = {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
    };

    return Network.execute('GET', 'get_document', params);
  }
}